<template>
  <v-dialog
    max-width="500"
    :value="show"
    persistent
    @input="close"
  >
    <v-card>
      <v-card-title class="headline">
        Lead Servicing Search
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="mb-0"
          >
            <v-select
              v-model="selectedInput"
              :items="inputs"
              item-value="name"
              item-title="label"
              label="Pick your search fields"
              outlined
              chips
              small-chips
              @change="$emit('change')"
            />
          </v-col>

          <v-col
            v-for="(input, i) in activeFormInputs"
            :key="i"
            cols="12"
          >
            <v-select
              v-if="input.items"
              v-model.trim="search[input.name]"
              :label="input.label"
              :items="input.items"
              filled
              dense
              hide-details
            />
            <v-text-field
              v-else
              v-model.trim="search[input.name]"
              :label="input.label"
              dense
              filled
              clearable
              required
              hide-details
            />
            <v-card-text
              v-if="searchErrorMsg"
              class="red--text"
            >
              {{ searchErrorMsg }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mt-12" />
      <v-card-actions>
        <v-btn
          color="orange darken-4"
          text
          @click="close"
        >
          Cancel
        </v-btn>

        <v-spacer />

        <v-btn
          color="primary"
          text
          :disabled="disableSubmit"
          @click="$emit('search', searchData)"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LeadServicingSearchForm',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inputs: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    searchErrorMsg: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectedInput: this.selected,
      search: {},
    };
  },

  computed: {
    activeFormInputs() {
      return this.inputs.filter((input) => this.selectedInput.includes(input.name));
    },

    searchData() {
      const searchData = {};
      searchData[this.selectedInput] = this.search[this.selectedInput];

      return Object.keys(searchData).length > 0 ? searchData : null;
    },

    disableSubmit() {
      return this.searchData === null || this.selectedInput.length === 0
        || (
          typeof (this.searchData.leadGuid) === 'undefined'
          && typeof (this.searchData.guid) === 'undefined'
          && typeof (this.searchData.email) === 'undefined'
          && typeof (this.searchData.phone) === 'undefined'
        );
    },

  },

  methods: {
    close() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped>
.v-dialog__content {
  align-items: start;
}
</style>
